<template>
	<v-card class="confirmation-card">
		<v-card-title class="text-h1 font-weight-bold" v-if="!!title">
			{{ title }}
			<v-spacer></v-spacer>
			<v-btn icon="mdi-close" @click="$emit('cancel')" :disabled="loading" variant="plain">
			</v-btn>
		</v-card-title>

		<slot></slot>

		<v-card-actions class="justify-end" :class="styles.actionButtonsContainerClass">
			<v-btn v-if="buttonOptions.cancelBtn.enabled" :color="styles.cancelButton.color"
				:variant="styles.cancelButton.variant"
				@click="cancel" :disabled="loading" :loading="loading">
				{{ buttonOptions.cancelBtn.message }}
			</v-btn>
			<v-btn v-if="buttonOptions.agreeBtn.enabled" :color="styles.agreeButton.color"
				:variant="styles.agreeButton.variant"
				@click="agree" class="ml-2"
				:disabled="loading || buttonOptions.agreeBtn.disabled">
				{{ buttonOptions.agreeBtn.message }}
			</v-btn>
		</v-card-actions>
	</v-card>
</template>
<script>

export default {
	name: "Confirmation",

	props: {
		title: {
			type: String,
			default: ""
		},
		buttonOptions: {
			type: Object,
			default() {
				return {
					agreeBtn: {
						enabled: true,
						message: "Yes"
					},
					cancelBtn: {
						enabled: true,
						message: "Cancel"
					}
				}
			}
		},
		styles: {
			type: Object,
			default() {
				return {
					messageClass: "text-center",
					actionButtonsContainerClass: "",
					agreeButton: {
						color: "primary",
						variant: "flat"
					},
					cancelButton: {
						color: "primary",
						variant: "text"
					}
				}
			}
		}
	},

	emits: ["agree", "cancel"],

	data() {
		return {
			loading: false
		}
	},

	methods: {
		agree() {
			this.loading = true;
			this.$emit("agree");
		},

		cancel() {
			this.loading = false;
			this.$emit("cancel");
		}
	}
}
</script>

<style lang="scss" scoped>
</style>